import script from "./MainMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMenu.vue?vue&type=script&setup=true&lang=js"

import "./MainMenu.vue?vue&type=style&index=0&id=78c92943&lang=scss"

const __exports__ = script;

export default __exports__